import { render, staticRenderFns } from "./productsSoldes.vue?vue&type=template&id=20831b65&"
import script from "./productsSoldes.vue?vue&type=script&lang=js&"
export * from "./productsSoldes.vue?vue&type=script&lang=js&"
import style0 from "./productsSoldes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports